module.exports = __webpack_public_path__ + "img/pony-ls.012fa559.jpg";